import { Box, SxProps, useTheme } from '@mui/material';
import MDEditor from '@uiw/react-md-editor';
import { type CSSProperties } from 'react';
import rehypeSanitize from 'rehype-sanitize';

type MarkdownDisplayProps = {
  source: string;
  style?: CSSProperties;
  containerSx?: SxProps;
};

export const MarkdownDisplay = ({ source, style, containerSx }: MarkdownDisplayProps) => {
  const { palette, typography } = useTheme();
  return (
    <Box
      sx={{
        '& .wmde-markdown': {
          color: palette.text.paper,
          backgroundColor: palette.background.paper,
          p: 1.5,
          height: '100%',
          '& p,td,li': {
            ...typography.caption2,
          },
          '& table': {
            overflowX: 'auto',
            border: `1px solid ${palette.table.cell.border}`,
          },
          ...style,
        },
        ...containerSx,
      }}
    >
      <MDEditor.Markdown source={source} rehypePlugins={[[rehypeSanitize]]} />
    </Box>
  );
};
